<template>
  <div>
    <el-dialog
      title="工单回复列表"
      width="80%"
      :visible.sync="visible"
      destroy-on-close
      center
      @before-close="beforeClose"
    >
      <section class="page-container">
        <div class="toolbar">
          <el-form :inline="true" :model="filters">
            <el-form-item>
              <el-button type="primary" @click="handleAdd">回复</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table
          v-loading="listLoading"
          :data="results"
          highlight-current-row
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="编号"></el-table-column>
          <!--
          <el-table-column
            prop="feedbackId"
            label="feedbackId"
          ></el-table-column>
          -->
          <el-table-column prop="userId" label="用户"></el-table-column>
          <el-table-column prop="content" label="内容"></el-table-column>
          <el-table-column prop="imageList" label="图片">
            <template slot-scope="scope">
              <div v-if="scope.row.imageList && scope.row.imageList.length">
                <el-image
                  v-for="(image, index) in scope.row.imageList"
                  :key="index"
                  :src="image.preview"
                  :preview-src-list="imageSrcList(scope.row.imageList)"
                  fit="cover"
                  style="width: 100px; height: 100px; margin-right: 10px"
                >
                </el-image>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="createTime" label="创建时间">
            <template slot-scope="scope">{{ scope.row.createTime | formatDate }}</template>
          </el-table-column>

          <!--
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
          -->
        </el-table>

        <div class="pagebar">
          <el-pagination
            :page-sizes="[20, 50, 100, 300]"
            :current-page="page.page"
            :page-size="page.limit"
            :total="page.total"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="handlePageChange"
            @size-change="handleLimitChange"
          >
          </el-pagination>
        </div>
      </section>
    </el-dialog>

    <el-dialog title="新增回复" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="80px">
        <el-input v-model="addForm.feedbackId" type="hidden"></el-input>

        <el-form-item label="内容">
          <el-input
            v-model="addForm.content"
            type="textarea"
            rows="6"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="图片">
          <admin-batch-image-upload v-model="addForm.imageList" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="editForm" :model="editForm" label-width="80px">
        <el-input v-model="editForm.id" type="hidden"></el-input>

        <el-form-item label="feedbackId">
          <el-input v-model="editForm.feedbackId"></el-input>
        </el-form-item>

        <el-form-item label="userId">
          <el-input v-model="editForm.userId"></el-input>
        </el-form-item>

        <el-form-item label="content">
          <el-input v-model="editForm.content"></el-input>
        </el-form-item>

        <el-form-item label="imageList">
          <el-input v-model="editForm.imageList"></el-input>
        </el-form-item>

        <el-form-item label="createTime">
          <el-input v-model="editForm.createTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="editLoading"
          @click.native="editSubmit"
          >提交</el-button
        >
      </div>
    </el-dialog>
    -->
  </div>
</template>

<script>
import AdminBatchImageUpload from "@/components/AdminBatchImageUpload";
export default {
  components: { AdminBatchImageUpload },
  data() {
    return {
      feedbackId: 0,
      visible: false,
      results: [],
      listLoading: false,
      page: {},
      filters: {
        feedbackId: 0,
      },
      selectedRows: [],

      addForm: {
        feedbackId: 0,
        content: "",
        imageList: "",
      },
      addFormVisible: false,
      addLoading: false,

      editForm: {
        feedbackId: 0,
        content: "",
        imageList: "",
      },
      editFormVisible: false,
      editLoading: false,
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    async show(feedbackId) {
      this.feedbackId = feedbackId;
      this.filters.feedbackId = feedbackId;
      this.visible = true;
      await this.list();
    },
    beforeClose() {
      this.filters.feedbackId = 0;
      this.addForm.feedbackId = 0;
      this.editForm.feedbackId = 0;
    },
    resetForm() {
      this.addForm.feedbackId = this.feedbackId;
      this.addForm.content = "";
      this.addForm.imageList = "";

      this.editForm.feedbackId = this.feedbackId;
      this.editForm.content = "";
      this.editForm.imageList = "";
    },
    async list() {
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("base:/api/admin/feedback-reply/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleAdd() {
      this.resetForm();
      this.addFormVisible = true;
    },
    async addSubmit() {
      try {
        await this.axios.form("base:/api/admin/feedback-reply/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("base:/api/admin/feedback-reply/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      try {
        await this.axios.form("base:/api/admin/feedback-reply/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },

    handleSelectionChange(val) {
      this.selectedRows = val;
    },

    imageSrcList(imageList) {
      if (!imageList || !imageList.length) {
        return [];
      }
      const ret = [];
      for (let i = 0; i < imageList.length; i++) {
        ret.push(imageList[i].preview);
      }
      return ret;
    },
  },
};
</script>

<style lang="scss" scoped></style>
